/**
 * The URL as a reader should SEE it: no scheme, no trailing slash.
 *
 * Display only (THI-192 §12.2). Every functional use of the value — `href`,
 * `navigator.clipboard.writeText`, the invoice message template — keeps the
 * full URL, because a scheme-less string is not a link. Chrome and Safari have
 * hidden `https://` in the omnibox for years; a 33.6px-tall truncating box has
 * better uses for those eight characters than repeating what every browser
 * already omits.
 *
 * Deliberately string surgery, not `new URL()`: `new URL` normalises (adds the
 * trailing slash back onto a bare origin, percent-encodes, lowercases the
 * host) and throws on anything it cannot parse, and this function must be
 * total — it renders inside a component with no error boundary of its own.
 */
export function displayUrl(url: string): string {
  const withoutScheme = url.replace(/^https?:\/\//i, '');
  return withoutScheme.endsWith('/') ? withoutScheme.slice(0, -1) : withoutScheme;
}
